/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./lens.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../core/portal-directives";
import * as i3 from "./lens.component";
var styles_UILensComponent = [i0.styles];
var RenderType_UILensComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_UILensComponent, data: {} });
export { RenderType_UILensComponent as RenderType_UILensComponent };
function View_UILensComponent_1(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵand(0, null, null, 0))], null, null); }
export function View_UILensComponent_0(_l) { return i1.ɵvid(0, [i1.ɵqud(402653184, 1, { _portalHost: 0 }), (_l()(), i1.ɵand(16777216, null, null, 1, null, View_UILensComponent_1)), i1.ɵdid(2, 147456, [[1, 4]], 0, i2.UIPortalHostDirective, [i1.ComponentFactoryResolver, i1.ViewContainerRef], null, null)], null, null); }
export function View_UILensComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ui-lens", [], null, [["window", "resize"]], function (_v, en, $event) { var ad = true; if (("window:resize" === en)) {
        var pd_0 = (i1.ɵnov(_v, 1)._onResize() !== false);
        ad = (pd_0 && ad);
    } return ad; }, View_UILensComponent_0, RenderType_UILensComponent)), i1.ɵdid(1, 49152, null, 0, i3.UILensComponent, [i1.ElementRef], null, null)], null, null); }
var UILensComponentNgFactory = i1.ɵccf("ui-lens", i3.UILensComponent, View_UILensComponent_Host_0, {}, {}, []);
export { UILensComponentNgFactory as UILensComponentNgFactory };
